
export enum BeaconTypeCd {
	ALERT = 'Alert',
	EXCEPTION = 'Exception',
	MESSAGE = 'Message'}

